import DisplayHubDetails from 'src/components/DisplayHubDetails';
import { DialogTypes } from 'src/components/RundownDialog';
import {
  PanelGroup,
  Panel,
  PanelResizeHandle as ResizeHandle,
} from 'src/components/ResizeablePanel';
import DisplayHubs from 'src/components/DisplayHubs';
import Playlists from 'src/components/Playlists';
import ViewWindow from 'src/components/ViewWindow/ViewWindow';

type Props = {
  rundown: Rundown;
  selectedPlaylistDisplayHub: PlaylistDisplayHub | null;
  setShowDialog: React.Dispatch<React.SetStateAction<DialogTypes | null>>;
};

function LayoutDisplayHub({ rundown, selectedPlaylistDisplayHub, setShowDialog }: Props) {
  const canvases = rundown.canvases.filter((canvas) =>
    canvas.graphics.some((g) => g.types.includes('displayHub'))
  );

  return (
    <div className="h-full">
      <PanelGroup direction="vertical">
        <Panel defaultSize={32} className="!bg-default-surface">
          <PanelGroup direction="horizontal">
            {canvases.map((canvas) => (
              <ViewWindow
                key={canvas.id}
                name={canvas.name}
                src={canvas.output?.liveUrl}
                liveMode
              />
            ))}
          </PanelGroup>
        </Panel>

        <ResizeHandle />

        <Panel>
          <PanelGroup direction="horizontal">
            <Panel defaultSize={20}>
              <PanelGroup direction="vertical">
                <Panel
                  header="Playlists"
                  icon="plus"
                  onClick={() => setShowDialog(DialogTypes.PLAYLIST)}
                  defaultSize={25}
                >
                  <Playlists rundownId={rundown.id} />
                </Panel>

                <ResizeHandle />

                <Panel
                  header="Display Hubs"
                  icon="plus"
                  onClick={() => setShowDialog(DialogTypes.DISPLAY_HUB)}
                >
                  <DisplayHubs />
                </Panel>
              </PanelGroup>
            </Panel>
            <ResizeHandle />
            <Panel>
              {selectedPlaylistDisplayHub && (
                <DisplayHubDetails
                  handleCreateStory={() => setShowDialog(DialogTypes.DISPLAY_HUB_STORY)}
                />
              )}
            </Panel>
          </PanelGroup>
        </Panel>
      </PanelGroup>
    </div>
  );
}

export default LayoutDisplayHub;
